module.exports = __webpack_public_path__ + "assets/img/d9db639bf95a0d002419b4470a1f2bbc.svg";